(() => {
  const normalizeText = (value = '') =>
    value
      .replace(/\bBestPrintsCo\b/g, 'Best Prints Co.')
      .replace(/\bUnicorn\s*Shoes\s*Shop\b/gi, 'Best Prints Co.')
      .replace(/\bUnicornshoesshop\b/gi, 'Best Prints Co.');

  const shouldSkipElement = (element) => {
    if (!element) return true;
    if (element.closest('script, style, textarea, input, select, option, [contenteditable="true"]')) return true;
    if (element.closest('.shopify-policy__container')) return true;
    if (window.location.pathname.startsWith('/policies/')) return true;
    return false;
  };

  const normalizeTextNode = (node) => {
    if (!node || node.nodeType !== Node.TEXT_NODE || shouldSkipElement(node.parentElement)) return;
    const updated = normalizeText(node.nodeValue || '');
    if (updated !== node.nodeValue) node.nodeValue = updated;
  };

  const normalizeRoot = (root) => {
    if (!root) return;

    if (root.nodeType === Node.TEXT_NODE) {
      normalizeTextNode(root);
      return;
    }

    if (!(root instanceof Element || root instanceof Document || root instanceof DocumentFragment)) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: (node) =>
        shouldSkipElement(node.parentElement) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT,
    });

    while (walker.nextNode()) normalizeTextNode(walker.currentNode);
  };

  const normalizeTitle = () => {
    const updated = normalizeText(document.title);
    if (updated !== document.title) document.title = updated;
  };

  const pendingRoots = new Set();
  let animationFrame = 0;

  const flushPending = () => {
    animationFrame = 0;
    normalizeTitle();
    pendingRoots.forEach(normalizeRoot);
    pendingRoots.clear();
  };

  const queueRoot = (node) => {
    if (!node) return;
    pendingRoots.add(node);
    if (!animationFrame) animationFrame = window.requestAnimationFrame(flushPending);
  };

  const runInitialPass = () => {
    normalizeTitle();
    normalizeRoot(document.body);
  };

  const startObserver = () => {
    if (!document.body) return;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'characterData') queueRoot(mutation.target);
        mutation.addedNodes.forEach(queueRoot);
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    window.addEventListener(
      'load',
      () => {
        window.setTimeout(() => observer.disconnect(), 10000);
      },
      { once: true }
    );
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        runInitialPass();
        startObserver();
      },
      { once: true }
    );
  } else {
    runInitialPass();
    startObserver();
  }
})();
